// extracted by mini-css-extract-plugin
module.exports = {"routeHeader":"messages_routeHeader_qKDHw","addButton":"messages_addButton_yc1_W"};